import { type FC, type PropsWithChildren, useEffect, useMemo } from 'react';
import { useAccount } from '@/hooks/data/account/useAccount';
import { useCurrentPage } from '@/hooks/useCurrentPage';
import { Loading } from '@/components/loading';
import { useRouter } from 'next/router';

export const GuestWall: FC<PropsWithChildren> = ({ children }) => {
  const { guest, profileLoading, isAuthLoading } = useAccount();
  const { replace } = useRouter();
  const { isBrowsePage, isPublicSharePage, isHomePage, isSubmitPage } = useCurrentPage();

  //isHomePage && isBrowsePage condition can be removed if we have a dedicated landing page for guest which we will add to the isPublicSharePage
  const shouldRedirect = useMemo(
    () =>
      guest && !isPublicSharePage && !isBrowsePage && !isHomePage && !isSubmitPage && !profileLoading && !isAuthLoading,
    [guest, isPublicSharePage, isBrowsePage, isHomePage, isSubmitPage, profileLoading, isAuthLoading],
  );

  useEffect(() => {
    if (shouldRedirect) {
      void replace('/browse');
    }
  }, [shouldRedirect, replace]);

  if (shouldRedirect || profileLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white dark:bg-neutral-950">
        <Loading />
      </div>
    );
  }

  return children;
};
